/* ----------------------------- */
/*   Reducer for the Individual Approver Set
/* ----------------------------- */

import { SET_INDIVIDUAL_APRROVER, CLEAR_INDIVIDUAL_APRROVER_LIST, DELETE_ALL_INDIVIDUAL_LIST } from 'AppSrc/core/approvers/approver-individual-actions';

const individualApproversReducerDefaultState = {
  ApproversList: [],
};

const individualApproverReducer = (state = individualApproversReducerDefaultState, action) => {

  switch (action.type) {
    // Set single approver and prevent duplicate entry
    case SET_INDIVIDUAL_APRROVER: {
      const isDuplicateApprover = state.ApproversList.some((param) => param.email === action.payload.approversData.email);
      if (isDuplicateApprover) {
        return {
          ...state,
        };
      }
      return {
        ...state,
        ApproversList: [...state.ApproversList, action.payload.approversData],
      };
    }
    // Delete Aprrover using email
    case CLEAR_INDIVIDUAL_APRROVER_LIST: {
      const removedData = state.ApproversList.filter((list) => list.email !== action.payload);
      return {
        ...state,
        ApproversList: removedData,
      };
    }
    // Delete All individual Approver List from main array
    case DELETE_ALL_INDIVIDUAL_LIST: {
      return {
        ApproversList: [],
      };
    }
    default:
      return state;
  }
};

export {
  individualApproverReducer,
  individualApproversReducerDefaultState,
};

